import { IInitOptions } from "../interfaces/initoptions";

declare var gtag: Function;

export function beginFacilityLead() {
    const initOptions: IInitOptions = (<any> window).initOptions;
    gtag("event", "begin_facility_lead", {
        event_category: "engagement",
        event_label: "Facility Lead Form Displayed",
        facilityId: initOptions.facilityId,
    });
}

export function sendFacilityLead() {
    const initOptions: IInitOptions = (<any> window).initOptions;
    gtag("event", "send_facility_lead", {
        event_category: "engagement",
        event_label: "Facility Lead Form Submitted",
        facilityId: initOptions.facilityId,
    });
}
